import Block from '../components/block';
import Counter from '../components/counter';
import { RotateCw } from 'lucide-react';
import { setGoals } from 'modules/stream/store/game-info/game-info';
import { theme } from 'styles/theme/theme';
import { useDispatch } from 'react-redux';
import useGameInfo from '../../hooks/use-game-info';

export function Score() {
  const dispatch = useDispatch();
  const { goals } = useGameInfo();

  const setScoreFirstTeam = (num: number) => {
    dispatch(setGoals({ ...goals, first: num }));
  };

  const setScoreSecondTeam = (num: number) => {
    dispatch(setGoals({ ...goals, second: num }));
  };

  const onClickReset = () => {
    dispatch(setGoals({ first: 0, second: 0 }));
  };

  return (
    <Block className={'flex-center flex-column'} headerText={'Счёт'}>
      <div className={'d-flex'} style={{ width: '100%', justifyContent: 'space-between' }}>
        <Counter value={goals.first} setValue={setScoreFirstTeam} />
        <RotateCw size={16} color={theme.colors.WhiteGray} onClick={onClickReset} />
        <Counter value={goals.second} setValue={setScoreSecondTeam} />
      </div>
    </Block>
  );
}
